export default class DebugToolVO {

    /**
     * Value object holding debug module parameters
     * @param {String} displayName 
     * @param {Constructor of debug module} classConstructor 
     */
    constructor(displayName, classConstructor) {
        this.displayName = displayName;
        this.classConstructor = classConstructor;
    }

}